import React,{useState, useRef, useEffect }  from "react";
import { useDispatch } from "react-redux";
import {  Link  } from "react-router-dom";
import { clientAppUserVerifyOTP } from "../../../store/actions/User";

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUpT1.css';
import Loading from "../../Loading/Loading";;

const ResetPassOTPT1 = ()=>{
  
const data = useSelector((state)=>state?.user?.user);
   
      
       const handleMouseEnter = () =>dispatch({
        type: "CURSOR",
        
        payload:true
      });
      const handleMouseLeave = () => dispatch({
        type: "CURSOR",
        
        payload:false
      });
          const loginSignUpPopUp = useSelector((state)=>state?.app?.loginSignUpPopUp);
        
           const [loginPopUp , setLoginPopUp] =useState(true);
      
  const [inputs, setInputs] = useState(['', '', '', '']); // State to hold input values

  const [MyOTPData, setMyOTPData] =  useState({userEmail:"",OTP:""})
   const inputRefs = useRef([...Array(4)].map(() => React.createRef())); // Refs for input fields
  const handleChange = (index, value) => {
    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);

    // If a digit is entered and there's another input field, focus on it
    if (value.length === 1 && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].current.focus();
    }
  };
  useEffect(() => {
    // Focus the input field when the component mounts
    inputRefs.current[0].current.focus();
    
 if(data?.change_password){
       
  history.push('/addNewPassWord');

}

  }, []); // Empty dependency array means this effect runs only once after the initial render

 const dispatch = useDispatch();
  

  const history = useHistory();
 
 const [loader , setLoader] =useState({status:false});

 

/* Handle Signup Function */
const handleVerifyOTP=(e)=>{
  e.preventDefault();
//console.log(signup)

 
setLoader({status:true});
  const user = dispatch(clientAppUserVerifyOTP({userEmail:data?.userEmail,OTP:inputs.join('')}));
  /* get response as Promise   */
  user.then(response => {
  
    if(response){
     
      if(response){
        dispatch({
          type: "LoginSignUpPopUp",
          
          payload:"addNewPassword"
        })
      

      }
      else
      {
        alert("no response")
     
      }
     

    }else{


    }
    ;
   


setLoader({status:false});


//history.push('/dashboard/profile');


  }).catch(error => {
   
setLoader({status:false});
    console.error(error);
  });
 
  }

    return <>
    
{<>

{<Loading  Load={loader?.status}/>}
  <form onSubmit={handleVerifyOTP} >{loginSignUpPopUp=="resetPassOTP"?<div onClick={() => dispatch({
    type: "LoginSignUpPopUp",
    
    payload:""
  })}  className="cm_theme1_login-signup-backgropj"></div>:""} <div  className="cm_theme1_login-signup-card"><div  className="blank"> </div>
  <div  className="cm_theme1_login-signup-card-outerj"><div  className="cm_theme1_login-signup-inner">
  <div  className="cm_theme1_blankRight cm_theme1_login-signup-right-signup">
      <div>   <div  className="flex-space-between">  <div  style={{width:"240px",padding:"15px",borderRadius:"15px",marginTop:"50px"}}><img style={{width:"100%"}}
            alt="logo" src="https://i.postimg.cc/7Zwy3WW9/Testprism_Logo.png"/> </div>
     
           </div>
           
     <h3  style={{textAlign:"center"}}>App Tag Line</h3>
     <div className="logo-box-shadow">
     <div className=""  style={{padding:'10px',color:"#222",fontSize:'22px',textAlign:"center"}}> Already Have An Account?   </div>
     <div  className=""  style={{padding:'10px',color:"#666",fontSize:'15px',textAlign:"center"}}>
       Login And Access Your Courses   . </div>
     
            <div className="flex-space-between"> 
            <div className="">
           
            {loginPopUp?<div
                     onClick={() => dispatch({
                       type: "LoginSignUpPopUp",
                       
                       payload:"login"
                     })} className="cm_theme1_course-btn-green-two" style={{fontSize:"16px"}}>
                      Login Here.
                     </div>:<Link to="./login">
                 <div className="ikcraft_course-btn-green-two" style={{fontSize:"16px"}}>
                Login Here.
               </div> </Link>}</div></div></div></div>
    </div>  <div  className="cm_theme1_login-signup-left-signup ">
      <h1 style={{"textAlign":"center"}}> Verify OTP </h1>
      
 <div  className="cm_theme1_login-input-card-otp">
     {inputs.map((value, index) => (
        <input className="cm_theme1_input-textbox-otp" required
          key={index}
          ref={inputRefs.current[index]}
          type="number"
          maxLength="1"
          value={value}
          onChange={(e) => handleChange(index, e.target.value)}
        />
      ))}
    </div>  
	  
   
   
    
   
     
   
	
	<div  className="cm_theme1_login-input-card">
   
  <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="cm_theme1_login-signup-button" type="submit" id="signupBtn">Click To Verify OTP</button>
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
    
  </div></div><div></div></div>
   </form>
</>}
    </>

}
export default ResetPassOTPT1;